import React, {useState, useRef, useEffect, useLayoutEffect } from "react";
import MessageBubble from "./message_bubble";

export default function AnnouncementsDrawer(props) {
    const messagesRef = useRef(null);          // the scrollable container (".messages")
    const keepPosRef = useRef({ pending: false, offsetFromBottom: 0 });

    const { showAnnouncements, announcements, iconPath, toggleAnnouncements } = props;
    const [showMoreCount, setShowMoreCount] = useState(0);
    const className = showAnnouncements ? "open" : "";

    function showMore() {
        const el = messagesRef.current;
        if (!el) return;
        keepPosRef.current.pending = true;
        keepPosRef.current.offsetFromBottom = el.scrollHeight - el.scrollTop;
        setShowMoreCount((c) => c + 10);
    }
    const unreadAnnouncements = announcements.filter((a) => !a.read);
    const startIndex = Math.max(0, announcements.length - showMoreCount - Math.max(unreadAnnouncements.length, 1));
    const announcementsToShow = announcements.slice(startIndex, announcements.length);

    useLayoutEffect(() => {
        if (!keepPosRef.current.pending) return;
        const el = messagesRef.current;
        if (!el) return;
        el.scrollTop = el.scrollHeight - keepPosRef.current.offsetFromBottom;
        keepPosRef.current.pending = false;
    }, [showMoreCount]);

    useLayoutEffect(() => {
        if (!messagesRef.current) return;
        if (keepPosRef.current.pending) return; // showMore will handle its own scroll fix
        if (showAnnouncements) {
            // Jump (or use behavior: 'smooth' if desired)
            messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
            // Or: bottomRef.current?.scrollIntoView({ block: "end" });
        }
    }, [showAnnouncements, announcements.length]);

    useEffect(() => {
        if (messagesRef.current) {
            messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
        }
    }, []);
    return (
        <div id="announcements-drawer" className={"assistant-drawer " + className}>
            <div className="assistant-drawer-header">
                Anuncios
                <div className="assistant-drawer-close" onClick={toggleAnnouncements} onKeyPress={() => {}}>&times;</div>
            </div>
            <div ref={messagesRef} className="messages">
                {startIndex !== 0 && (<div className="show-more" onClick={showMore} onKeyPress={() => {}}>
                    Ver anteriores
                </div>)}
                {announcementsToShow.map ((announcement) => (
                    <MessageBubble
                        key={announcement.id || announcement.date}
                        message={announcement.text}
                        read={announcement.read}
                        date={announcement.date}
                        iconPath={iconPath}
                    />
                ))}
            </div>
        </div>
    );
}
